<script setup lang="ts">
import type { AccordionItemModel } from '@su4r-frontend/api';

defineProps<AccordionItemModel>();
const isOpen = ref<boolean>(false);
const toggleAccordion = (): void => {
    isOpen.value = !isOpen.value;
};
</script>

<template>
    <div class="accordion-item group">
        <button
            class="text-brand-black flex w-full cursor-pointer items-center justify-between text-left leading-6 font-semibold"
            :aria-expanded="isOpen"
            :aria-controls="removeWhiteSpaceAndSpecialCharacters(title)"
            @click="toggleAccordion()">
            <div class="title flex-1">
                {{ title }}
            </div>
            <SvgComponent
                icon="chevron-down"
                class="w-4 transition-transform duration-300"
                :class="{ 'rotate-180': isOpen }" />
        </button>
        <div
            :id="removeWhiteSpaceAndSpecialCharacters(title)"
            class="grid grid-rows-[0fr] overflow-hidden pb-4 transition-[grid-template-rows] duration-300 group-last-of-type:pb-0"
            :class="{ 'grid-rows-[1fr]': isOpen }"
            role="region">
            <div class="text-brand-black overflow-hidden text-base" v-html="body"></div>
        </div>
    </div>
</template>
